import { useQuery } from '@tanstack/react-query';
import { Camera } from 'lucide-react';
import { useState } from 'react';
import { AttendanceCard, type AttendanceRecord } from '../components/AttendanceCard';
import { WfhRequestsCard } from '../components/WfhRequestsCard';
import { EmptyState } from '../components/ui/EmptyState';
import { SelfieViewerModal } from '../components/ui/SelfieViewerModal';
import { api } from '../lib/api';
import { Loader } from '../components/ui/Spinner';

export function AttendancePage() {
  const query = useQuery({ queryKey: ['attendance'], queryFn: async () => (await api.get<AttendanceRecord[]>('/api/attendance')).data });
  const [viewing, setViewing] = useState<AttendanceRecord | null>(null);

  return (
    <>
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Attendance</h1>
        <p className="mt-1 text-muted">GPS and a selfie are captured when you punch.</p>
      </div>

      <div className="mb-6"><AttendanceCard /></div>
      <div className="mb-6"><WfhRequestsCard /></div>

      <div className="space-y-3">
        {query.isLoading && <Loader />}
        {query.data?.length === 0 && <EmptyState title="No attendance recorded yet" />}
        {query.data?.map((row) => (
          <article className="card flex items-center justify-between gap-3" key={row.id}>
            <div className="min-w-0">
              <strong>{new Date(`${row.workDate}T00:00:00`).toLocaleDateString('en-IN', { dateStyle: 'medium' })}</strong>
              <p className="mt-1 text-sm text-muted">{row.checkInAt ? new Date(row.checkInAt).toLocaleTimeString('en-IN') : 'No punch'} — {row.checkOutAt ? new Date(row.checkOutAt).toLocaleTimeString('en-IN') : 'Open'}</p>
            </div>
            <div className="flex shrink-0 items-center gap-2">
              <span className="badge">{row.status.replace('_', ' ')}</span>
              {row.checkInMode === 'wfh' && <span className="badge bg-slate-100 text-slate-700">WFH</span>}
              {row.checkInSelfieUrl && <button type="button" className="btn-secondary !px-3" aria-label="View selfie" onClick={() => setViewing(row)}><Camera size={16} /></button>}
            </div>
          </article>
        ))}
      </div>

      {viewing && (
        <SelfieViewerModal
          title={new Date(`${viewing.workDate}T00:00:00`).toLocaleDateString('en-IN', { dateStyle: 'medium' })}
          checkIn={{ at: viewing.checkInAt, selfieUrl: viewing.checkInSelfieUrl, lat: viewing.checkInLat, lng: viewing.checkInLng }}
          checkOut={{ at: viewing.checkOutAt, selfieUrl: viewing.checkOutSelfieUrl, lat: viewing.checkOutLat, lng: viewing.checkOutLng }}
          onClose={() => setViewing(null)}
        />
      )}
    </>
  );
}
